import { Box, Stack } from "@mui/material";
import { required, useRecordContext, useTranslate } from "react-admin";
import { useFormContext } from 'react-hook-form';
import XTextInput from "../../components/XTextInput";


interface IRoleFormProps {
  isCreate: boolean;
}
const RoleForm = (props: IRoleFormProps) => {
  const { isCreate } = props;
  const translate = useTranslate();
  const { watch } = useFormContext();
  const record = useRecordContext();
  return (
    <Box sx={{ p: 3, pl: 0, pr:0 }}>
      <Stack spacing={3}>
        <XTextInput
          source="name"
          label="module.roles.name"
          validate={[required()]}
        />
      </Stack>
    </Box>
  );
};
export default RoleForm;  